import { Fragment, Suspense, useEffect, useState } from "react";
//import './App.css';
import { useTranslation } from "react-i18next";
import { Route, Routes } from "react-router-dom";
import MainRouter from "./MainRouter";
import {
  ActivateDevice,
  AGBComponent,
  ErrorBoundary,
  Header,
  Interview,
  NewPassword,
  Settings,
  Stammformular,
} from "./components";
import FormPreview from "./components/FormularGenerator/FormPreview";
import MessageBox from "./components/shared/components/MessageBox";
import { DEBUG_FLAG } from "./constants/debug";
import { LOCAL_STORAGE_KEY } from "./constants/localStorage";
import { useAuth, useClient } from "./context/auth-context";
import { useMessage } from "./context/message-context";
import { useLocalStorage, useSessionStorage } from "./utils/hooks";
import VerifyAccount from "./verifyAccount";
function AuthenticatedApp() {
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const [title, setTitle] = useState("");
  const [, setRefreshToken] = useLocalStorage(LOCAL_STORAGE_KEY.refreshToken);
  const [username] = useLocalStorage(LOCAL_STORAGE_KEY.username);
  const [deviceId] = useLocalStorage(
    DEBUG_FLAG() ? LOCAL_STORAGE_KEY.deviceIdLocal : LOCAL_STORAGE_KEY.deviceId
  );
  const [useDeviceAuth, setUseDeviceAuth] = useLocalStorage(
    LOCAL_STORAGE_KEY.useDeviceAuth
  );
  const [messageBoxOpen, setMessageBoxOpen] = useState(false);
  const { showErrorMessage } = useMessage();
  const [accessToken] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);
  const apiRequest = useClient();
  const { user } = useAuth();
  const deviceAuthIosCb = (data) => {
    setUseDeviceAuth("true");
    setRefreshToken(data.refreshToken);
  };
  const deviceAuthAndroidCb = (data) => {
    setRefreshToken(data.refreshToken);
    var encryptConfig = {
      clientId: "ectool",
      username: username.replace("/", ""),
      password: data.refreshToken,
      maxAttempts: 5,
      locale: "de",
      dialogTitle: "Authorisierung",
      dialogMessage: "Bitte legen Sie Ihren Finger auf",
    }; // See config object for required parameters
    // Set config and success callback
    window.FingerprintAuth.encrypt(
      encryptConfig,
      function (_fingerResult) {
        console.log("successCallback(): " + JSON.stringify(_fingerResult));
        setUseDeviceAuth("true");
        localStorage.setItem(
          LOCAL_STORAGE_KEY.androidToken,
          _fingerResult.token
        );
        if (_fingerResult.withFingerprint) {
          console.log("Successfully encrypted credentials.");
        } else if (_fingerResult.withBackup) {
          console.log("Authenticated with backup password");
        }
        // Error callback
      },
      function (err) {
        setRefreshToken("");
        if (err === "Cancelled") {
          console.log("FingerprintAuth Dialog Cancelled!");
        } else {
          console.log("FingerprintAuth Error: " + err);
          setUseDeviceAuth("false");
        }
      }
    );
  };

  useEffect(() => {
    const handleResume = () => {
      reloadUser()
    };

    document.addEventListener("resume", handleResume);

    return () => {
      document.removeEventListener("resume", handleResume);
    };
  }, []);

  useEffect(() => {
    // SSO-Daten aus dem Cache löschen
    if (window && window.sessionStorage && window.sessionStorage.getItem("SSO"))
      window.sessionStorage.removeItem("SSO");

    if (
      window.cordova &&
      useDeviceAuth !== "false" &&
      useDeviceAuth !== "true" &&
      user.deviceActivated === "J"
    ) {
      switch (window.cordova.platformId) {
        case "android":
          window.FingerprintAuth.isAvailable(
            function (result) {
              console.log(
                "FingerprintAuth available: " + JSON.stringify(result)
              );
              // If has fingerprint device and has fingerprints registered
              if (
                result.isAvailable === true &&
                result.hasEnrolledFingerprints === true
              ) {
                openMessageBox();
              }
            },
            function (message) {
              console.log("isAvailableError(): " + message);
            }
          );
          break;
        case "ios":
          openMessageBox();
          break;
        default:
          setUseDeviceAuth("false");
          break;
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (DEBUG_FLAG()) {
      localStorage.setItem(LOCAL_STORAGE_KEY.deviceIdLocal, deviceId);
    } else {
      localStorage.setItem(LOCAL_STORAGE_KEY.deviceId, deviceId);
    }
  }, [deviceId]);
  useEffect(() => {
    if (user.privateAccess === "J") {
      localStorage.setItem(LOCAL_STORAGE_KEY.private, "true");
    } else {
      localStorage.setItem(LOCAL_STORAGE_KEY.private, "false");
    }
    if (user.language !== "") {
      localStorage.setItem(LOCAL_STORAGE_KEY.language, user.language);
      console.log(user.language);
      i18n.changeLanguage(user.language);
      // if (user.language === "AR") {
      //   document.documentElement.setAttribute('dir', 'rtl');
      // }
      console.log(user.language);
    }
  }, [user]);
  useEffect(() => {
    localStorage.setItem("useDeviceAuth", useDeviceAuth);
  }, [useDeviceAuth]);
  const openMessageBox = () => {
    setMessageBoxOpen(true);
  };
  const closeMessageBox = () => {
    setMessageBoxOpen(false);
  };
  function messageBoxResult(r) {
    const payload = {
      deviceId: deviceId,
      status: true,
    };
    if (r === "YES") {
      switch (window.cordova.platformId) {
        case "android":
          apiRequest("deviceauth", { data: payload })
            .then(deviceAuthAndroidCb)
            .catch(() => {
              showErrorMessage(
                t("Geräteauthentifizierung konnte nicht aktiviert werden")
              );
            });
          // Check the docs to know more about the encryptConfig object :)
          break;
        case "ios":
          window.CID.checkAuth(
            "Prüfe Geräteauthentifizierung",
            function (res) {
              if (res === "success") {
                apiRequest("deviceauth", { data: payload })
                  .then(deviceAuthIosCb)
                  .catch(() => {
                    showErrorMessage(
                      t("Geräteauthentifizierung konnte nicht aktiviert werden")
                    );
                  });
                //setUseDeviceAuth('true');
              } else {
                showErrorMessage(t("Geräteauthentifizierung fehlgeschlagen"));
              }
            },
            function (err) {
              showErrorMessage(t("Geräteauthentifizierung fehlgeschlagen"));
              setUseDeviceAuth("false");
            }
          );
          break;
      }
    } else {
      setUseDeviceAuth("false");
    }
    closeMessageBox();
  }

  // .. im Falle Anwender ruft die SSO-URL (manuell) erneut auf? (bspw. Browser zurück)
  // !! .. ggf. Anpassung an dieser Stelle für Registrierung/Verknüpfung?
  if (
    window &&
    window.location &&
    window.location.pathname &&
    window.location.pathname.toLowerCase() === "/sso"
  ) {
    var url_fallback = window.location.origin;
    if (window.location.hash) url_fallback += "/" + window.location.hash;
    window.location.replace(url_fallback);
    return <>'/sso' invalid .. you will be redirected</>;
  }

  const renderAuthenticatedApp = () => {
    if (user.startpassword === "J") {
      return <NewPassword />;
    }
    if (
      user.agb === "" ||
      user.agb === "00000000" ||
      Number(user.agb) < Number(user.currentagb)
    ) {
      return <AGBComponent />;
    }
    if (user.deviceActivated !== "J") {
      return <ActivateDevice />;
    }
    if (user.stammformular === "J") {
      return (
        <Suspense fallback={<Fragment />}>
          <Routes>
            <Route
              path="/interview/:interview"
              element={
                <ErrorBoundary errorComponent="Interview">
                  <Interview accessToken={accessToken} />
                </ErrorBoundary>
              }
            />
            <Route
              path="/settings"
              element={
                <ErrorBoundary errorComponent="Settings">
                  <Settings
                    deviceId={deviceId}
                    accessToken={accessToken}
                    updateTitle={(t) => setTitle(t)}
                  />
                </ErrorBoundary>
              }
            />
            <Route
              path="/*"
              element={
                <ErrorBoundary errorComponent="Stammformular">
                  <Stammformular accessToken={accessToken} />
                </ErrorBoundary>
              }
            />
          </Routes>
        </Suspense>
      );
    }
    if (user.verifyUsers) {
      return <VerifyAccount />;
    }
    return <MainRouter setTitle={(t) => setTitle(t)} />;
  };
  return (
    <div className="AuthenticatedApp">
      <Suspense fallback={<Fragment />}>
        <Routes>
          <Route
            path="/formpreview/:formKey"
            element={
              <ErrorBoundary errorComponent="FormPreview">
                <FormPreview />
              </ErrorBoundary>
            }
          />

          <Route
            path="/*"
            element={
              <>
                <Header title={title} onTitleChange={setTitle} />
                <div className="ectool-content-scroll" id="ectool-scroll-container">
                  {renderAuthenticatedApp()}
                </div>
                <MessageBox
                  title={t("Hinweis")}
                  text={t(
                    "Wollen Sie sich in Zukunft über das Gerät anmelden?"
                  )}
                  buttons="YESNO"
                  onClose={closeMessageBox}
                  open={messageBoxOpen}
                  handleResponse={messageBoxResult}
                />
              </>
            }
          />
        </Routes>
      </Suspense>
    </div>
  );
}
export default AuthenticatedApp;
